/**
 * @author: lv.chen3
 * @desc: Project的Option的text组件
 * @date: 2025/3/23
 */
import React from 'react';
import classnames from 'classnames';
import EllipsisHover from '@gp/components/EllipsisHover';
import GeneralImageNew from '@gp/components/GeneralImageNew';
import { getTextWithHighlight } from '@intelligence/utils/commonUtils';
import { GET_TEXT_WITH_HIGHLIGHT_OPTION } from '@gp/constants/const';

import type { IBaseProps } from '@home/types/common';

import './index.scss';

interface IOptionTextProps extends IBaseProps {
  searchValue?: string;
  text?: string;
  cover?: string;
}

const OptionText: React.FC<IOptionTextProps> = (props) => {
  const { style, className, searchValue, text, cover } = props;
  const textFormatted = !searchValue
    ? text
    : getTextWithHighlight(text || '', searchValue, GET_TEXT_WITH_HIGHLIGHT_OPTION);

  return (
    <div style={style} className={classnames('dbg-pipeline-project-switcher-option-body', className)}>
      <GeneralImageNew
        className="dbg-pipeline-project-switcher-option-body__cover"
        domain="game"
        src={cover || ''}
        width={24}
        height={24}
      />
      <span className="dbg-pipeline-project-switcher-option-body__text">
        {/* @ts-ignore */}
        <EllipsisHover text={textFormatted || ''} bubbleText={text} />
      </span>
    </div>
  );
};

export default OptionText;
